import { render, staticRenderFns } from "./WeekRowItemDb.vue?vue&type=template&id=ccc8a8fe"
import script from "./WeekRowItemDb.ts?vue&type=script&lang=ts&external"
export * from "./WeekRowItemDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports